// extracted by mini-css-extract-plugin
export var accent = "Button-module--accent--aca94";
export var button = "Button-module--button--09beb";
export var buttonContent = "Button-module--buttonContent--ca302";
export var colorDefault = "Button-module--colorDefault--e75b8";
export var contained = "Button-module--contained--cbdd5";
export var endIcon = "Button-module--endIcon--78fd2";
export var error = "Button-module--error--7aa78";
export var fullWidth = "Button-module--fullWidth--daab1";
export var inherit = "Button-module--inherit--e3e67";
export var large = "Button-module--large--666df";
export var medium = "Button-module--medium--f6cce";
export var outlined = "Button-module--outlined--43309";
export var primary = "Button-module--primary--bcf23";
export var ripple = "Button-module--ripple--49681";
export var rippleEffect = "Button-module--rippleEffect--1ecb4";
export var rounded = "Button-module--rounded--e4dfa";
export var secondary = "Button-module--secondary--5606a";
export var small = "Button-module--small--45129";
export var startIcon = "Button-module--startIcon--e3980";
export var text = "Button-module--text--691dc";
export var tiny = "Button-module--tiny--d8558";
export var topIcon = "Button-module--topIcon--8d7ea";
export var white = "Button-module--white--910bb";